define('lq/events/actions/urlGenerator',[
    'lq',
    'lq/events/actions/eventAction'
], function (lq, EventAction) {
    'use strict';

    function UrlGenerator(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.values = eventData.values;
    }

    EventAction.extend(UrlGenerator, EventAction);

    UrlGenerator.typeName = 'UrlGenerator';

    UrlGenerator.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    UrlGenerator.prototype.execute = function (continuation) {
        this.piping.parameters.locals.setValue(this.values.targetParameter, this.getFullUrl());

        continuation();
    };
    
    UrlGenerator.prototype.getFullUrl = function () {
        if (this.values.generator === 'url') {
            return this.values.url + '?' + $.param(this.getParameters());
        } else {
            var url = this.getBaseUrl();
            return url + '?' + $.param(this.getParameters());
        }
    };

    UrlGenerator.prototype.getBaseUrl = function () {
        switch(this.values.generator) {
            case 'action':
                return lq.getFullUrl(lq.getTenantUrl('LicquidAction/Get/' + this.values.actionId));
            case 'actionIdFromParameter':
                return lq.getFullUrl(lq.getTenantUrl('LicquidAction/Get/' + this.piping.parameters.getValue(this.values.actionIdParameter)));
            case 'application':
                return lq.getFullUrl(lq.getBaseUrl(lq.getTenantName() + '/' + this.values.application.applicationName + '/LicquidAction/Get/' + this.values.application.actionId));
        }

        throw new Error('Invalid url generator');
    };

    UrlGenerator.prototype.getParameters = function () {
        var parameters = {};

        var locals = {};
        for (var i = 0; i < this.values.parameters.length; i++) {
            var name = this.values.parameters[i].name;
            var value = this.piping.parameters.getValue(name);
            locals[name] = value;
        }
        parameters['parameters'] = JSON.stringify(locals);

        if (this.values.includeGlobals) {
            var globals = this.piping.parameters.globals.getAll();
            parameters['globals'] = JSON.stringify(globals);
        }

        return parameters;
    };

    return UrlGenerator;
});
